module.exports = "pegasus/assets/themelp1/ebook/100.png";